<template>
  <div class="c-bar px">
    <div class="bar-menu-button" @click="menuVisible = true"></div>
    <div class="bar-menu-new" v-if="!systemInfo.isLatestVersion">new</div>
    <div
      class="bar-menu-content"
      :class="{ active: menuVisible }"
      v-show="menuVisible"
      @click="menuVisible = false"
    >
      <div class="bar-menu" @click.stop>
        <div class="bar-menu-item" @click="menuVisible = false">
          <i class="iconfont iconhome" /> {{ $t("home") }}
        </div>
        <div class="bar-menu-item" @click="openCommunity">
          <i class="iconfont icongroup" /> {{ $t("community") }}
        </div>
        <div class="bar-menu-item" @click="onItemClick($paths.settings)">
          <i class="iconfont iconsettings" /> {{ $t("settings") }}
          <span class="new" v-if="!systemInfo.isLatestVersion">new</span>
        </div>
        <md-menu
          class="language-menu"
          md-align-trigger
          md-direction="bottom-start"
        >
          <div class="bar-menu-item" md-menu-trigger>
            <img
              v-if="language === 'cn'"
              :src="images.lang_cn"
              alt="language"
            />
            <img
              v-else-if="language === 'en'"
              :src="images.lang_en"
              alt="language"
            />
            <img
              v-else-if="language === 'ja'"
              :src="images.lang_ja"
              alt="language"
            />
            {{ $t("language") }}
          </div>
          <md-menu-content class="language-list px">
            <md-menu-item @click="setLanguage('cn')">中文</md-menu-item>
            <md-menu-item @click="setLanguage('en')">English</md-menu-item>
            <md-menu-item @click="setLanguage('ja')">日本語</md-menu-item>
          </md-menu-content>
        </md-menu>
      </div>
    </div>
    <div
      class="bar-content"
      v-show="
        !$route.path.includes($paths.deviceList) &&
        !$route.path.includes($paths.welcome)
      "
    >
      <div class="settings-menu">
        <template
          v-if="
            $route.path.includes($paths.firmware) ||
            $route.path.includes($paths.laboratory) ||
            $route.path.includes('/keyboard')
          "
        >
          <div
            class="settings-menu-item firmware"
            :class="{ active: $route.path.includes($paths.firmware) }"
            @click="onItemClick($paths.firmware)"
          ></div>
          <div
            class="settings-menu-item keyboard"
            :class="{ active: $route.path.includes('/keyboard') }"
            @click="onKeyboardClick"
            v-show="
              !['hatsu', 'cyberblade', 'dongle'].includes(currentDevice.code)
            "
          ></div>
        </template>
        <template v-if="$route.path.includes('/mouse')">
          <div
            class="settings-menu-item mouse"
            :class="{ active: $route.path.includes($paths.mouse) }"
            @click="onItemClick($paths.mouse)"
          ></div>
          <div
            class="settings-menu-item mouse-firmware"
            :class="{ active: $route.path.includes($paths.mouseFirmware) }"
            @click="onItemClick($paths.mouseFirmware)"
          ></div>
        </template>
        <template v-if="$route.path.includes('/dongle-mouse')">
          <div
            class="settings-menu-item mouse"
            :class="{ active: $route.path.includes($paths.dongleMouse) }"
            @click="onItemClick($paths.dongleMouse)"
          ></div>
          <div
            class="settings-menu-item mouse-firmware"
            :class="{
              active: $route.path.includes($paths.dongleMouseFirmware),
            }"
            @click="onItemClick($paths.dongleMouseFirmware)"
          ></div>
        </template>
      </div>
      <div class="back" v-if="isQT" @click="$router.replace($paths.deviceList)">
        <i class="iconfont iconarrow-left" />
      </div>
      <template v-else>
        <div class="back" @click="onUpdate">
          <span class="new" v-if="!mouse.isLatestVersion">new</span>
          <i class="iconfont iconsettings" />
        </div>
        <div class="back">
          <md-menu
            class="language-menu"
            md-align-trigger
            md-direction="top-start"
          >
            <md-button class="language" md-menu-trigger>
              <img
                v-if="language === 'cn'"
                :src="images.lang_cn"
                alt="language"
              />
              <img
                v-else-if="language === 'en'"
                :src="images.lang_en"
                alt="language"
              />
              <img
                v-else-if="language === 'ja'"
                :src="images.lang_ja"
                alt="language"
              />
              <br />
              {{ $t("language") }}
            </md-button>
            <md-menu-content class="language-list px">
              <md-menu-item @click="setLanguage('cn')">中文</md-menu-item>
              <md-menu-item @click="setLanguage('en')">English</md-menu-item>
              <md-menu-item @click="setLanguage('ja')">日本語</md-menu-item>
            </md-menu-content>
          </md-menu>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { Modal } from "ant-design-vue";
import { download } from "@/utils";

export default {
  name: "CBar",
  data() {
    return {
      menuVisible: false,
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
      language: "language",
      isTest: "isTest",
    }),
    ...mapState("loader", {
      systemInfo: "systemInfo",
      currentDevice: "currentDevice",
      loading: "loading",
      isQT: "isQT",
    }),
    ...mapState(["mouse"]),
    ...mapState("assets", {
      images: "images",
    }),
    deviceList() {
      return this.systemInfo.deviceList;
    },
    winUrl() {
      return `https://angrymiao-www.oss-cn-shenzhen.aliyuncs.com/diy/AMasterDriverSetup${
        this.isTest ? "Test" : ""
      }.zip`;
    },
    macUrl() {
      return `https://angrymiao-www.oss-cn-shenzhen.aliyuncs.com/diy/AMasterDriverSetupMac${
        this.isTest ? "Test" : ""
      }.zip`;
    },
  },
  methods: {
    onItemClick(path) {
      this.menuVisible = false;
      this.$router.replace(path);
    },
    openCommunity() {
      this.$store.dispatch("loader/openCommunity");
    },
    onUpdate() {
      this.$store.dispatch("loader/setLoading", false);
      Modal.destroyAll();
      if (this.mouse.isLatestVersion) {
        this.$info({
          title: this.$t("loader.isLatestVersion").replace("*", ""),
          okText: this.$t("yes"),
        });
      } else {
        loader;
        this.$confirm({
          title: this.$t("loader.forceUpdate", ["AMasterDriver"]),
          okText: this.$t("loader.update"),
          cancelText: this.$t("cancel"),
          centered: true,
          onOk: () => {
            const isMac = navigator.platform.toUpperCase().includes("MAC");
            if (isMac) {
              download(this.macUrl, "AMasterDriverSetupMac.zip");
            } else {
              download(this.winUrl, "AMasterDriverSetup.zip");
            }
          },
        });
      }
    },
    setLanguage(lang) {
      const language = { cn: "zh_CN", en: "en_US", ja: "ja_JP" }[lang];
      this.$store.dispatch("app/setLanguage", language);
      this.$store.dispatch("loader/setLanguage", language);
      // this.$store.dispatch("loader/setSystemInfo", {
      //   ...this.systemInfo,
      //   language,
      // });
    },
    onKeyboardClick() {
      let path = this.$paths.keyboardNew;
      switch (this.currentDevice.code) {
        case "cb02":
        case "cb03":
        case "cb04":
        case "cb05":
        case "cb06":
        case "cb_terminal":
        case "cb_tm_01":
        case "cb_matrix":
          path = this.$paths.keyboardNew;
          break;
        case "alice":
          path = this.$paths.keyboardAlice;
          break;
        case "hatsu":
          path = this.$paths.keyboardHatsu;
          break;
        case "65les":
        case "65les_r1":
        case "65les_r2":
          path = this.$paths.keyboard65Less;
          break;
        case "am28":
        case "am_28":
          path = this.$paths.keyboard65GameBoy;
          break;
        case "am21":
          path = this.$paths.keyboard80;
          break;
        case "dr001":
          path = this.$paths.keyboard75;
          break;
        case "dr002":
          path = this.$paths.keyboard65Fluffy;
          break;

        default:
          path = this.$paths.keyboardNew;
          break;
      }
      this.$router.replace(path);
      this.$store.dispatch("loader/setLoading", true);
      setTimeout(() => {
        this.$store.dispatch("loader/syncJSON");
      }, 500);
    },
  },
  watch: {
    deviceList(list) {
      if (
        !document.querySelector(".c-progress div") &&
        this.$route.path.includes("mouse")
      ) {
        if (list.length <= 0 && !this.loading) {
          this.$router.replace(this.$paths.welcome);
        }
        if (this.currentDevice.port && this.currentDevice.code) {
          const device = list.find(
            (item) =>
              item.port == this.currentDevice.port &&
              item.code == this.currentDevice.code
          );
          if (!device) {
            this.$store.dispatch("loader/setCurrentDevice", {
              port: "",
              code: "",
              updateDescription: { zh_CN: "", en_US: "" },
            });
            this.$router.replace(this.$paths.welcome);
          }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.c-bar.px {
  width: 60px;
  height: 100vh;

  .bar-menu-button {
    width: 60px;
    height: 60px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    background: url("../assets/images/icon_menu.svg") center / 26px 26px
      no-repeat;
    cursor: pointer;
  }

  .bar-menu-new {
    width: 40px;
    font-size: 12px;
    text-align: center;
    color: #ffffff;
    border-radius: 100px;
    position: fixed;
    left: 10px;
    top: 50px;
    z-index: 1000;
    background: $active-color;
  }

  .bar-menu-content {
    width: 100vw;
    height: 100vh;
    background: rgba(23, 23, 23, 0.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;

    .bar-menu {
      width: 250px;
      height: 100%;
      background: #000000;
      padding-top: 140px;

      .bar-menu-item {
        width: 250px;
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        color: #9f9f9f;
        cursor: pointer;

        .iconfont {
          font-size: 16px;
        }

        img {
          width: 20px;
          height: 20px;
        }

        .new {
          width: 40px;
          display: inline-block;
          font-size: 12px;
          text-align: center;
          color: #ffffff;
          border-radius: 100px;
          background: $active-color;
        }

        &:hover,
        &:focus {
          background: #222222;
          color: #ffffff;
        }
      }
    }
  }

  .bar-content {
    @include flex-center;
    flex-direction: column;
    width: 60px;
    height: 100vh;
    background: #202020;
    position: fixed;
    left: 0;
    top: 0;
    padding: 10px 0;
    z-index: 1000;

    .settings-menu {
      width: 100%;
      flex: auto;
      cursor: pointer;

      .settings-menu-item {
        width: 100%;
        height: 40px;
        margin-bottom: 10px;

        &.firmware,
        &.mouse-firmware {
          background: url("../assets/images/icon_firmware.svg") center / 26px
            26px no-repeat;

          &.active,
          &:hover {
            background-image: url("../assets/images/icon_firmware_active.svg");
          }
        }

        &.keyboard {
          background: url("../assets/images/icon_keyboard.svg") center / 26px
            26px no-repeat;

          &.active,
          &:hover {
            background-image: url("../assets/images/icon_keyboard_active.svg");
          }
        }

        &.mouse {
          background: url("../assets/images/icon_mouse.svg") center / 26px 26px
            no-repeat;

          &.active,
          &:hover {
            background-image: url("../assets/images/icon_mouse_active.svg");
          }
        }

        &.mouse-dongle-firmware {
          background: url("../assets/images/icon_dongle.svg") center / 26px 26px
            no-repeat;

          &.active,
          &:hover {
            background-image: url("../assets/images/icon_dongle_active.svg");
          }
        }
      }
    }

    .back {
      width: 100%;
      color: #9f9f9f;
      text-align: center;
      padding: 5px 0;
      cursor: pointer;

      .iconfont {
        font-size: 24px;
      }

      &:hover {
        color: $primary-color;
      }

      .new {
        width: 40px;
        display: inline-block;
        font-size: 12px;
        text-align: center;
        color: #ffffff;
        border-radius: 100px;
        background: $active-color;
      }
    }

    .language-menu {
      width: 100%;
      overflow: hidden;
    }

    .language {
      width: 60px;
      height: 50px;
      display: block;
      font-size: 10px;

      img {
        width: 20px;
        height: 20px;
        margin-bottom: 5px;
      }
    }
  }
}

.language-list {
  z-index: 1001;
}
</style>

<style lang="scss">
.c-bar.px .language .md-ripple {
  width: 60px;
  padding: 0;
}
</style>
